import React from "react";
import { useParams } from "react-router-dom";
import InnerHeader from "./InnerHeader";
import ServicesSidebar from "./ServicesSidebar";
import ServicesContent from "./ServicesContent";
import CtaSec from "./CtaSec";

const Services = () => {
  const { serviceKey } = useParams();

  return (
    <div className="services-page">
      <InnerHeader heading="Our Services" />
      <section className="main-services-sec">
        <div className="container">
          <div className="row row-gap-25">
            <div className="col-lg-3 col-12">
              <ServicesSidebar activeTab={serviceKey || "distribution"} />
            </div>
            <div className="col-lg-9 col-12">
              <ServicesContent serviceKey={serviceKey || "distribution"} />
            </div>
          </div>
        </div>
      </section>
      <CtaSec />
    </div>
  );
};

export default Services;
